import React, { useEffect, useState } from "react";
import { FormControl, InputGroup, Row } from "react-bootstrap";
import "./NotificationPage.css";
import default_product from "./../../../assets/default_product.png";
import { connect } from "react-redux";
import { timeSince } from "./../../comman/components/TimeSence";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import no_notification from "./../../../assets/no_notification.svg";
import { useTranslation } from "react-i18next";
import { updateNotifictioncount } from "../../user/dashboard/redux/actions";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getRequestcall } from "../../comman/util/getRequest";
import { NOTIFICATION } from "../../constants/apiurl";
import PaginationPage from "../../comman/components/PaginationPage";

function NotificationPage(props) {
  const { access_token } = props;
  const { t } = useTranslation();
  let getType = window.location.pathname.split("/");
  const [search, setSearch] = useState("");
  const [nopagination, setNopagination] = useState(false);
  const [notificationList, setNotificationList] = useState({
    total: 1,
    data: [],
  });
  const [links, setLinks] = useState([]);

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.sidenav.manage_noti"), "", "");
    openNotificationlist(1);
    // eslint-disable-next-line
  }, [props.language]);

  const openNotificationlist = async (page) => {
    let apiurl = NOTIFICATION + `?page=${page}&lang=${props?.language?.toLowerCase()}`;
    let getResponsecall = await getRequestcall(apiurl, access_token);
    if (getResponsecall?.status === 200) {
      let notificationList = await getResponsecall.json();
      console.log("notification length",notificationList)
      if (notificationList?.data?.data?.length === 0) {
        setNopagination(true);
      } else {
        if (props?.dashboard === true) {
          let recentlyList = notificationList?.data?.data.filter(
            (item, index) => index < 5
          );
          setNotificationList({
            ...notificationList,
            data: recentlyList,
          });
        } else {
          setNotificationList({
            data: notificationList?.data?.data,
            total: notificationList?.data?.total,
          });
        }
        setLinks(notificationList?.data?.links);
        props.updateNotifictioncount(notificationList?.data?.data[0]?.count);
        setNopagination(false);
      }
    }
  };

  const changeCurrentpage = async (page) => {
    await openNotificationlist(page);
  };

  if (nopagination) {
    return (
      <NodatafoundPage
        className={"col-xl-12 main-content transaction-centent"}
        image={no_notification}
        button={t("pages.backtodashboard")}
        title={t("pages.notifications.noreview")}
        description={t("pages.notifications.noreview_description")}
        navigation={
          getType[1] === "vendor" ? "/vendor/dashboard" : "/user/dashboard"
        }
      />
    );
  }

  return (
    <div className="col-xl-9 main-content notification-centent">
      {!props?.dashboard && (
        <div className="block-inline mb-4">
          <div className="left-side">
            <h5 className="header-title">{t("pages.notifications.title")}</h5>
          </div>
          <div className="right-side align-center">
            <InputGroup className="">
              <InputGroup.Text id="basic-addon1"></InputGroup.Text>
              <FormControl
                type={"text"}
                id={"search"}
                onChange={(e) => setSearch(e?.target?.value)}
                name={"search"}
                placeholder={t("pages.notifications.search")}
              />
            </InputGroup>
          </div>
        </div>
      )}
      <Row className={"mt-2"}>
        <div>
          <div className="col-12 noti-list">
            {!notificationList?.data ? (
              <div className="p-3 text-center">
                <h5 className="font-16">{t("pages.nodatafound")}</h5>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  {notificationList?.data
                    ?.filter((item) => {
                      const data = item?.title
                        ?.toLowerCase()
                        ?.includes(search?.toLowerCase());
                      return data;
                    })
                    ?.map((item, indexs) => (
                      <div
                        key={indexs.toString()}
                        className="d-flex align-center justify-space-between noti-row"
                      >
                        <div className="profile-user">
                          <div className="images">
                            <LazyLoadImage
                              src={item?.image ? item?.image : default_product}
                              alt={""}
                              onError={(e) => {
                                e.target.src = default_product;
                              }}
                            />
                          </div>
                          <div className="infos">
                            {item.title?.split("#")[1] !== undefined && (
                              <>
                                <label>
                                  <b>{t("pages.orderid")} </b>:{" "}
                                  {item.title?.split("#")[1]}
                                </label>
                              </>
                            )}
                            <label className="name">
                              {item.title?.split("#")[0]}
                            </label>
                            <span className="date">
                              {timeSince(new Date(item.created_at), t)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </Row>
      {!nopagination && !props?.dashboard && notificationList?.total > 10 && (
        <div className="text-end">
          <PaginationPage
            changeCurrentpage={changeCurrentpage}
            nopagination={nopagination}
            links={links}
          />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  updateNotifictioncount,
  fetchHeaderContent,
})(NotificationPage);
